import React from 'react'
import { ArchivoComponent } from './ArchivoComponent'
import { useSelector } from 'react-redux'
import estilos from './ArchivoComponent.module.css'

const ArchivosInstalacionesFC_36 = (props) => {

    const {tabla, id, api, idAnexoFK = undefined, filesMap = undefined, opcionSelect = undefined} = props
    const {handdleFile, handdleRemovePrev, files} = api
    const anexoInfo = props.anexo.fc_36informaciongeneral
    const [opcionTipoArchivoComercializador, setOpcionTipoArchivoComercializador] = React.useState("")
    const {handleChangeOptionFile, handdleRemoveOptionFile, deletePrevFile, opcion} = opcionSelect
    const modoCorreccion = useSelector(store => store.FC_36Solicitud.modoCorreccion)

    const changeOption = (value) => {
        if(value !== "" && opcionTipoArchivoComercializador === ""){
            handleChangeOptionFile({ id: id, opcionFile: value, idAnexoFK: idAnexoFK })
        }else if(value !== "" && opcionTipoArchivoComercializador !== ''){
            deletePrevFile(files, id)
            handdleRemoveOptionFile({ id: id, opcionFile: value, idAnexoFK: idAnexoFK})
        }
    }
    const handleSetOptionLocalFromParent = () => {
        opcion.map((field, index) => {
            if(field.id === id){
                setOpcionTipoArchivoComercializador(field.opcionFile)
            }
        })
    }
    React.useEffect(() => {
        handleSetOptionLocalFromParent()
    }, [opcionSelect])
    
    return (
        <div className={`col-md-12 mb-3 `}>
            <div className='row'>
                <div className='col-md-4'>
                    <label className="text-center textoParaArchivos"><strong>Comprobante de posesión de la instalación alias {anexoInfo.alias}</strong></label><br/>
                </div>
                <div className={`col-md-8 ${estilos.selectorFile}`}>
                    <div className="form-floating mb-2">
                        <select className={`form-select form-select-sm`} value={opcionTipoArchivoComercializador} onChange={e => changeOption(e.target.value)} disabled={modoCorreccion && filesMap?.[0] !== undefined}>
                            <option value="">Seleccione una opción</option>
                            <option value="copiatitulopropiedad">Copia del título de propiedad a nombre del solicitante</option>
                            <option value="contratoarrendamientopublico">Copia del contrato de arrendamiento público</option>
                            <option value="contratoarrendamientoprivado">Contrato de arrendamiento privado</option>
                            <option value="contratocomodatopublico">Copia del contrato comodato público</option>
                            <option value="contratocomodatoprivado">Contrato comodato privado</option>
                        </select>
                        {/* <span className='text-danger'>{fc_01Map?.sexo}</span> */}
                    </div>
                </div>
            </div>
            {
                opcionTipoArchivoComercializador === 'copiatitulopropiedad' ? 
                <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`TITULOINS${id}`} tabla={tabla} textLabel="Copia del título de propiedad a nombre del solicitante" idAnexoFK={idAnexoFK} filesMap={filesMap}/> : 
                opcionTipoArchivoComercializador === 'contratoarrendamientopublico' ? 
                <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CAINSP${id}`}tabla={tabla} textLabel="Contrato de arrendamiento público (notariado)" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                : 
                opcionTipoArchivoComercializador === 'contratoarrendamientoprivado' ?
                <div>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CAINS${id}`} tabla={tabla} textLabel="Contrato de arrendamiento" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`IOVRINS${id}`} tabla={tabla} textLabel="Identificación oficial vigente del Arrendador" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`IOVOINS${id}`} tabla={tabla} textLabel="Identificación oficial vigente del Arrendatario" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <hr/>
                </div> : 
                opcionTipoArchivoComercializador === 'contratocomodatopublico' ? 
                <div>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CCINSP${id}`} tabla={tabla} textLabel="Contrato comodato público (notariado)" idAnexoFK={idAnexoFK} filesMap={filesMap}/>  
                </div> :
                opcionTipoArchivoComercializador === 'contratocomodatoprivado' ? 
                <div>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`CCINS${id}`} tabla={tabla} textLabel="Contrato comodato" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`IOVEINS${id}`} tabla={tabla} textLabel="Identificación oficial vigente del comodante" idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <ArchivoComponent api={{handdleFile, handdleRemovePrev, files}} id={`IOVOINS${id}`} tabla={tabla} textLabel="Identificación oficial vigente del comodatario " idAnexoFK={idAnexoFK} filesMap={filesMap}/>
                    <hr/>
                </div> : ('')
            }
        </div>
    )
}

export default ArchivosInstalacionesFC_36